import { render } from "./IconDownloads.vue?vue&type=template&id=2f6b6e09"
import script from "./IconDownloads.vue?vue&type=script&lang=js"
export * from "./IconDownloads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__